(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsible-tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-accordion]').forEach(function(container) {
  var allDetails = container.querySelectorAll('details.disclosure');
  allDetails.forEach(function(detail) {
    detail.addEventListener('toggle', function() {
      if (this.open) {
        allDetails.forEach(function(other) {
          if (other !== detail) {
            other.open = false;
          }
        });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-instagram-video-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initSection(root) {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const mobileBreakpoint = Number(root.dataset.mobileBreakpoint || 768);
      const videoAutoplayMs = Number(root.dataset.videoAutoplayMs || 5000);
      const productAutoplayMs = Number(root.dataset.productAutoplayMs || 5000);
      const enableCarousel = root.dataset.enableCarousel === 'true';
      const videoTrack = root.querySelector('[data-video-track]');
      const videoPagination = root.querySelector('[data-video-pagination]');
      const videoNav = root.querySelector('[data-video-nav]');
      const videoPrev = root.querySelector('[data-video-prev]');
      const videoNext = root.querySelector('[data-video-next]');
      const videoCards = Array.from(root.querySelectorAll('.sigallery__video-card'));
      const videoModal = root.querySelector('[data-video-modal]');
      const videoModalContent = root.querySelector('[data-video-modal-content]');
      const videoClose = root.querySelector('[data-video-close]');

      const variantModal = root.querySelector('[data-variant-modal]');
      const variantClose = root.querySelector('[data-variant-close]');
      const variantSelect = root.querySelector('[data-variant-select]');
      const variantPicker = root.querySelector('[data-variant-picker]');
      const variantTrigger = root.querySelector('[data-variant-trigger]');
      const variantTriggerText = root.querySelector('[data-variant-trigger-text]');
      const variantOptions = root.querySelector('[data-variant-options]');
      const variantConfirm = root.querySelector('[data-variant-confirm]');
      const variantProductTitle = root.querySelector('[data-variant-product-title]');
      const variantError = root.querySelector('[data-variant-error]');
      const successNotice = root.querySelector('[data-add-success]');

      let selectedVariant = null;
      let videoAutoTimer = null;
      const productAutoTimers = [];
      const bodyEl = document.body;
      const htmlEl = document.documentElement;

      function clearTimer(timer) {
        if (timer) window.clearInterval(timer);
      }

      function clearProductTimers() {
        productAutoTimers.forEach((timer) => clearTimer(timer));
        productAutoTimers.length = 0;
      }

      function lockPageScroll() {
        if (!bodyEl || !htmlEl) return;
        const activeLocks = Number(bodyEl.dataset.sigalleryScrollLockCount || 0);
        if (activeLocks === 0) {
          const currentScrollY = window.scrollY || window.pageYOffset || 0;
          bodyEl.dataset.sigalleryScrollY = String(currentScrollY);
          bodyEl.style.top = `-${currentScrollY}px`;
          bodyEl.classList.add('sigallery-scroll-locked');
          htmlEl.classList.add('sigallery-scroll-locked');
        }
        bodyEl.dataset.sigalleryScrollLockCount = String(activeLocks + 1);
      }

      function unlockPageScroll() {
        if (!bodyEl || !htmlEl) return;
        const activeLocks = Number(bodyEl.dataset.sigalleryScrollLockCount || 0);
        if (activeLocks <= 1) {
          const scrollY = Number(bodyEl.dataset.sigalleryScrollY || 0);
          bodyEl.classList.remove('sigallery-scroll-locked');
          htmlEl.classList.remove('sigallery-scroll-locked');
          bodyEl.style.removeProperty('top');
          delete bodyEl.dataset.sigalleryScrollY;
          delete bodyEl.dataset.sigalleryScrollLockCount;
          window.scrollTo(0, scrollY);
          return;
        }
        bodyEl.dataset.sigalleryScrollLockCount = String(activeLocks - 1);
      }

      function updateDots(dotWrap, total, active, onClick) {
        if (!dotWrap || total <= 1) {
          if (dotWrap) dotWrap.innerHTML = '';
          return;
        }
        dotWrap.innerHTML = '';
        for (let i = 0; i < total; i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = `sigallery__dot${i === active ? ' is-active' : ''}`;
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => onClick(i));
          dotWrap.appendChild(dot);
        }
      }

      function showSuccess(message) {
        if (!successNotice) return;
        successNotice.textContent = message || 'Added to cart';
        successNotice.hidden = false;
        window.setTimeout(() => {
          successNotice.hidden = true;
        }, 2200);
      }

      function refreshCartUi(data) {
        const sectionsToUpdate = ['page-header', 'cart-drawer']
          .map((tag) => document.querySelector(tag))
          .filter((el) => el);

        if (data && data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
          sectionsToUpdate.forEach((el) => {
            if (typeof el.updateFromCartChange === 'function') {
              el.updateFromCartChange(data.sections[el.dataset.sectionId]);
            }
          });
        } else {
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }

        const drawer = document.querySelector('.js-cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
        }
      }

      async function addToCart(variantId, button) {
        if (!variantId) return;
        if (button) {
          button.disabled = true;
          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');
        }
        if (variantError) {
          variantError.hidden = true;
          variantError.textContent = '';
        }

        try {
          const sectionsToUpdate = ['page-header', 'cart-drawer']
            .map((tag) => document.querySelector(tag))
            .filter((el) => el);
          const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId);
          const formData = new FormData();
          formData.append('id', String(variantId));
          formData.append('quantity', '1');
          formData.append('sections_url', window.location.pathname);
          formData.append('sections', sectionIds.join(','));

          const response = await fetch(window.theme?.routes?.cartAdd || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });
          const data = await response.json();

          if (data.status || !response.ok) {
            throw new Error(data?.description || data?.message || 'Unable to add this product.');
          }

          if (variantModal?.open) variantModal.close();
          if (videoModal?.open) videoModal.close();
          refreshCartUi(data);
          showSuccess('Product added to cart');
        } catch (error) {
          if (variantError) {
            variantError.hidden = false;
            variantError.textContent = error.message || 'Unable to add this product.';
          }
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        } finally {
          if (button) {
            button.disabled = false;
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
          }
        }
      }

      function closeVariantDropdown() {
        if (!variantPicker || !variantTrigger || !variantOptions) return;
        variantPicker.classList.remove('is-open');
        variantTrigger.setAttribute('aria-expanded', 'false');
        variantOptions.hidden = true;
      }

      function openVariantDropdown() {
        if (!variantPicker || !variantTrigger || !variantOptions) return;
        variantPicker.classList.add('is-open');
        variantTrigger.setAttribute('aria-expanded', 'true');
        variantOptions.hidden = false;
      }

      function setSelectedVariant(variantId) {
        selectedVariant = String(variantId || '');
        if (variantSelect) variantSelect.value = selectedVariant;

        if (variantTriggerText && variantSelect) {
          const selectedOption = variantSelect.querySelector(`option[value="${selectedVariant}"]`);
          variantTriggerText.textContent = selectedOption ? selectedOption.textContent : 'Choose variant';
        }

        if (variantOptions) {
          variantOptions.querySelectorAll('[data-variant-option-id]').forEach((optionBtn) => {
            const isSelected = optionBtn.dataset.variantOptionId === selectedVariant;
            optionBtn.classList.toggle('is-selected', isSelected);
            optionBtn.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          });
        }
      }

      function renderVariantOptions(variants) {
        if (!variantOptions) return;
        variantOptions.innerHTML = '';
        variants.forEach((variant) => {
          const item = document.createElement('li');
          item.setAttribute('role', 'presentation');

          const optionButton = document.createElement('button');
          optionButton.type = 'button';
          optionButton.className = 'sigallery__variant-option';
          optionButton.setAttribute('role', 'option');
          optionButton.setAttribute('aria-selected', 'false');
          optionButton.setAttribute('data-variant-option-id', String(variant.id));
          optionButton.textContent = variant.title;

          item.appendChild(optionButton);
          variantOptions.appendChild(item);
        });
      }

      function openVariantModal(productData) {
        if (!variantModal || !variantSelect) return;
        const variants = (productData?.variants || []).filter((variant) => variant.available);
        variantSelect.innerHTML = '';
        selectedVariant = null;

        variants.forEach((variant, index) => {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.title;
          variantSelect.appendChild(option);
          if (index === 0) selectedVariant = String(variant.id);
        });
        renderVariantOptions(variants);
        setSelectedVariant(selectedVariant);
        closeVariantDropdown();

        if (variantProductTitle) {
          variantProductTitle.textContent = productData?.title || '';
        }
        if (variantError) {
          variantError.hidden = true;
          variantError.textContent = '';
        }
        if (typeof variantModal.showModal === 'function') variantModal.showModal();
      }

      function setupProductCards() {
        root.addEventListener('click', (event) => {
          const addBtn = event.target.closest('[data-add-product]');
          if (!addBtn || !root.contains(addBtn)) return;
          if (addBtn.disabled || addBtn.classList.contains('sigallery__add--disabled')) return;

          const card = addBtn.closest('[data-product-card]');
          if (!card || !root.contains(card)) return;

          const productJsonEl = card.querySelector('[data-product-json]');
          if (!productJsonEl) return;

          let productData = null;
          try {
            productData = JSON.parse(productJsonEl.textContent);
          } catch (_error) {
            productData = null;
          }
          if (!productData) return;

          const availableVariants = (productData.variants || []).filter((variant) => variant.available);
          if (!availableVariants.length) return;
          if (availableVariants.length === 1) {
            addToCart(availableVariants[0].id, addBtn);
            return;
          }
          openVariantModal(productData);
        });
      }

      function setFallbackProductSlide(state, index) {
        state.items.forEach((item, itemIndex) => {
          item.style.display = itemIndex === index ? 'flex' : 'none';
        });
      }

      function startFallbackAutoScroll(state) {
        if (!state || state.total <= 1) return;
        const timer = window.setInterval(() => {
          state.index = (state.index + 1) % state.total;
          setFallbackProductSlide(state, state.index);
          updateDots(state.pagination, state.total, state.index, (dotIndex) => {
            state.index = dotIndex;
            setFallbackProductSlide(state, dotIndex);
          });
        }, productAutoplayMs);
        productAutoTimers.push(timer);
      }

      function initProductSliders() {
        root.querySelectorAll('[data-product-list]').forEach((list) => {
          const count = Number(list.dataset.productCount || 0);
          const pagination = list.parentElement.querySelector('[data-product-pagination]');
          const navWrap = list.parentElement.querySelector('[data-product-nav]');
          const prevBtn = list.parentElement.querySelector('[data-product-prev]');
          const nextBtn = list.parentElement.querySelector('[data-product-next]');
          const useSlick = window.jQuery && typeof window.jQuery.fn.slick === 'function';
          const $list = useSlick ? window.jQuery(list) : null;

          list.removeAttribute('style');
          Array.from(list.children).forEach((child) => child.removeAttribute('style'));

          if (count <= 1) {
            if ($list && $list.hasClass('slick-initialized')) {
              $list.slick('unslick');
            }
            if (pagination) pagination.innerHTML = '';
            if (navWrap) navWrap.hidden = true;
            return;
          }

          if (navWrap) navWrap.hidden = false;

          if (useSlick) {
            if (!$list.hasClass('slick-initialized')) {
              $list.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !!(prevBtn && nextBtn),
                prevArrow: prevBtn ? window.jQuery(prevBtn) : undefined,
                nextArrow: nextBtn ? window.jQuery(nextBtn) : undefined,
                dots: true,
                autoplay: false,
                adaptiveHeight: true,
                appendDots: pagination ? window.jQuery(pagination) : window.jQuery(list)
              });
            }
            return;
          }

          list.style.display = 'block';
          list.style.overflow = 'hidden';

          const state = {
            index: 0,
            total: count,
            items: Array.from(list.children),
            pagination
          };
          setFallbackProductSlide(state, 0);
          updateDots(pagination, count, 0, (dotIndex) => {
            state.index = dotIndex;
            setFallbackProductSlide(state, dotIndex);
          });
          if (prevBtn) {
            prevBtn.onclick = () => {
              state.index = (state.index - 1 + state.total) % state.total;
              setFallbackProductSlide(state, state.index);
              updateDots(pagination, state.total, state.index, (dotIndex) => {
                state.index = dotIndex;
                setFallbackProductSlide(state, dotIndex);
              });
            };
          }
          if (nextBtn) {
            nextBtn.onclick = () => {
              state.index = (state.index + 1) % state.total;
              setFallbackProductSlide(state, state.index);
              updateDots(pagination, state.total, state.index, (dotIndex) => {
                state.index = dotIndex;
                setFallbackProductSlide(state, dotIndex);
              });
            };
          }
        });
      }

      function initVideoSlider() {
        if (enableCarousel) {
          if (window.jQuery && typeof window.jQuery.fn.slick === 'function' && videoTrack) {
            const $track = window.jQuery(videoTrack);
            if ($track.hasClass('slick-initialized')) {
              $track.slick('unslick');
            }
          }
          return;
        }

        if (!videoTrack || videoCards.length <= 1) {
          if (videoPagination) videoPagination.innerHTML = '';
          return;
        }

        const useSlider = videoCards.length > 6;
        if (!useSlider) {
          if (window.jQuery && typeof window.jQuery.fn.slick === 'function') {
            const $track = window.jQuery(videoTrack);
            if ($track.hasClass('slick-initialized')) {
              $track.slick('unslick');
            }
          }
          if (videoNav) videoNav.hidden = true;
          if (videoPagination) videoPagination.innerHTML = '';
          return;
        }

        const useSlick = window.jQuery && typeof window.jQuery.fn.slick === 'function';
        if (useSlick) {
          const $track = window.jQuery(videoTrack);
          if (!$track.hasClass('slick-initialized')) {
            $track.slick({
              slidesToShow: 6,
              slidesToScroll: 1,
              arrows: true,
              prevArrow: videoPrev ? window.jQuery(videoPrev) : undefined,
              nextArrow: videoNext ? window.jQuery(videoNext) : undefined,
              dots: true,
              appendDots: videoPagination ? window.jQuery(videoPagination) : window.jQuery(videoTrack),
              autoplay: true,
              autoplaySpeed: videoAutoplayMs,
              responsive: [
                { breakpoint: 1200, settings: { slidesToShow: 4 } },
                { breakpoint: mobileBreakpoint, settings: { slidesToShow: 2 } },
                { breakpoint: 640, settings: { slidesToShow: 1 } }
              ]
            });
          }
          if (videoNav) videoNav.hidden = false;
          return;
        }

        if (videoNav) videoNav.hidden = true;
        if (videoPagination) videoPagination.innerHTML = '';
      }

      function initInfiniteCarouselNav() {
        if (!enableCarousel || videoCards.length < 4) return;
        const navWrap = root.querySelector('.sigallery__header-nav');
        const sliderEl = root.querySelector('.sigallery__video-track.slider');
        if (!navWrap) return;
        if (!sliderEl) return;

        const syncButtons = () => {
          navWrap.querySelectorAll('button.slider-nav__btn[name="prev"], button.slider-nav__btn[name="next"]').forEach((btn) => {
            if (btn.disabled) {
              btn.setAttribute('aria-disabled', 'true');
              btn.disabled = false;
            } else {
              btn.removeAttribute('aria-disabled');
            }
          });
        };

        syncButtons();
        const navObserver = new MutationObserver(syncButtons);
        navWrap.querySelectorAll('button.slider-nav__btn[name="prev"], button.slider-nav__btn[name="next"]').forEach((btn) => {
          navObserver.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
        });

        navWrap.addEventListener('click', (event) => {
          const button = event.target.closest('button.slider-nav__btn[name="prev"], button.slider-nav__btn[name="next"]');
          if (!button) return;

          const slides = Array.from(sliderEl.querySelectorAll('.slider__item'));
          if (slides.length < 2) return;

          const firstOffset = slides[0].offsetLeft;
          const secondOffset = slides[1].offsetLeft;
          const slideSpan = Math.max(1, secondOffset - firstOffset);
          const maxScroll = Math.max(0, sliderEl.scrollWidth - sliderEl.clientWidth);
          const currentScroll = sliderEl.scrollLeft;
          const edgeThreshold = Math.max(2, slideSpan / 3);
          const nearStart = currentScroll <= edgeThreshold;
          const nearEnd = currentScroll >= maxScroll - edgeThreshold;

          if (button.name === 'next' && nearEnd) {
            event.preventDefault();
            event.stopPropagation();
            sliderEl.scrollTo({ left: 0, behavior: 'smooth' });
          } else if (button.name === 'prev' && nearStart) {
            event.preventDefault();
            event.stopPropagation();
            sliderEl.scrollTo({ left: Math.max(0, maxScroll - edgeThreshold), behavior: 'smooth' });
          }
        });

        root.addEventListener('shopify:section:unload', () => {
          navObserver.disconnect();
        });
      }

      function resetVideoModalAndProductSliders() {
        clearProductTimers();
        if (videoModalContent) videoModalContent.innerHTML = '';
        initProductSliders();
      }

      function pauseModalVideo() {
        const modalVideo = videoModalContent?.querySelector('.sigallery__video-modal-media');
        if (modalVideo && typeof modalVideo.pause === 'function') modalVideo.pause();
      }

      function bindVideoModal() {
        root.querySelectorAll('[data-video-open]').forEach((trigger) => {
          trigger.addEventListener('click', () => {
            if (!videoModal || !videoModalContent) return;
            const wrap = trigger.closest('.sigallery__video-wrap');
            const template = wrap?.querySelector('[data-video-template]');
            if (!template) return;

            const videoCard = trigger.closest('.sigallery__video-card');
            videoModalContent.innerHTML = '';

            const layout = document.createElement('div');
            layout.className = 'sigallery__video-modal-layout';

            const main = document.createElement('div');
            main.className = 'sigallery__video-modal-main';
            main.appendChild(template.content.cloneNode(true));

            const aside = document.createElement('aside');
            aside.className = 'sigallery__video-modal-side';
            aside.setAttribute('aria-label', 'Products linked to this video');

            if (videoCard) {
              const productArticles = videoCard.querySelectorAll('.sigallery__product-card');
              if (productArticles.length) {
                const productsSection = document.createElement('section');
                productsSection.className = 'sigallery__products sigallery__products--modal';

                const head = videoCard.querySelector('.sigallery__products-head');
                if (head) {
                  productsSection.appendChild(head.cloneNode(true));
                }

                const list = document.createElement('div');
                list.className = 'sigallery__products-list sigallery__products-list--modal';
                productArticles.forEach((article) => {
                  const clone = article.cloneNode(true);
                  clone.removeAttribute('style');
                  clone.querySelectorAll('[style]').forEach((node) => node.removeAttribute('style'));
                  list.appendChild(clone);
                });
                productsSection.appendChild(list);

                aside.appendChild(productsSection);
              }
            }

            if (!aside.children.length) {
              layout.classList.add('sigallery__video-modal-layout--single');
            }

            layout.appendChild(main);
            layout.appendChild(aside);
            videoModalContent.appendChild(layout);

            clearProductTimers();
            initProductSliders();

            const modalVideo = main.querySelector('video.sigallery__video-modal-media');
            if (modalVideo && typeof modalVideo.play === 'function') {
              modalVideo.play().catch(() => {});
            }

            if (typeof videoModal.showModal === 'function') {
              videoModal.showModal();
              lockPageScroll();
            }
          });
        });

        if (videoClose) {
          videoClose.addEventListener('click', () => {
            if (videoModal?.open) videoModal.close();
          });
        }

        if (videoModal) {
          videoModal.addEventListener('click', (event) => {
            if (event.target === videoModal) {
              videoModal.close();
            }
          });

          videoModal.addEventListener('close', () => {
            unlockPageScroll();
            pauseModalVideo();
            resetVideoModalAndProductSliders();
          });
        }
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', (event) => {
          setSelectedVariant(event.target.value);
        });
      }
      if (variantTrigger) {
        variantTrigger.addEventListener('click', () => {
          if (!variantOptions || !variantOptions.children.length) return;
          if (variantPicker?.classList.contains('is-open')) {
            closeVariantDropdown();
          } else {
            openVariantDropdown();
          }
        });
      }
      if (variantOptions) {
        variantOptions.addEventListener('click', (event) => {
          const optionBtn = event.target.closest('[data-variant-option-id]');
          if (!optionBtn) return;
          setSelectedVariant(optionBtn.dataset.variantOptionId);
          closeVariantDropdown();
        });
      }
      if (variantConfirm) {
        variantConfirm.addEventListener('click', () => addToCart(selectedVariant, variantConfirm));
      }
      if (variantClose) {
        variantClose.addEventListener('click', () => {
          closeVariantDropdown();
          if (variantModal?.open) variantModal.close();
        });
      }
      if (variantModal) {
        variantModal.addEventListener('click', (event) => {
          if (event.target === variantModal) {
            closeVariantDropdown();
            variantModal.close();
          }
        });
        variantModal.addEventListener('close', () => {
          closeVariantDropdown();
        });
      }
      root.addEventListener('click', (event) => {
        if (!variantPicker || !variantPicker.classList.contains('is-open')) return;
        if (!variantPicker.contains(event.target)) {
          closeVariantDropdown();
        }
      });

      setupProductCards();
      initProductSliders();
      initVideoSlider();
      initInfiniteCarouselNav();
      bindVideoModal();

      const handleResize = () => {
        clearTimer(videoAutoTimer);
        clearProductTimers();
        initProductSliders();
        initVideoSlider();
      };

      window.addEventListener('resize', handleResize, { passive: true });
      root.addEventListener('shopify:section:unload', () => {
        clearTimer(videoAutoTimer);
        clearProductTimers();
        if (videoModal?.open) {
          try {
            videoModal.close();
          } catch (_error) {}
        } else {
          unlockPageScroll();
        }
        window.removeEventListener('resize', handleResize);
      });
    }

    function initAll() {
      document.querySelectorAll('.sigallery').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
